export const GREE_1 = '#275c53';
export const GREE_3 = 'aquamarine';
export const GREE_2 = '#f7fbfd';
export const GRAY_1 = 'rgba(0, 0, 0, 0.1)';
export const GRAY_2= '#F4F9FC';
export const GRAY_3= '#333';